import api from "../../api";
import { adapterOptions, NAConverter, onlyUnique } from "../../utils";
import { adapterTags } from "../../utils/adapter-tags";
import subAdapter from './adapter.sub'
import eventAdapter from '../event/adapter'
import blogAdapter from '../blog/adapter'
import resourceAdapter from '../resource/adapter'
import dayjs from "dayjs";

const adapter = {
  formToBasicRequestBody(input){
    let output = {}

    if(input){
      const {
        title_en = '',
        title_id = '',
        about_en = 'N/A',
        about_id = 'N/A',
        start_date = new Date().toISOString(),
        end_date = new Date().toISOString(),
        suitable = [],
        approach = [],
        issue = [],
        tags = [],
        officers = [],
        status = {},
        submission
      } = input

      output = {
        judulActivity: [title_id, title_en],
        deskripsiPendek: [NAConverter(about_id), NAConverter(about_en)],
        deskripsiPanjang: [NAConverter(about_id), NAConverter(about_en)],
        tanggalMulai: new Date(start_date).toISOString(),
        tanggalSelesai: new Date(end_date).toISOString(),
        officer: officers.map((o) => o.value),
        tag: tags.map((s) => s.value),
        typeAudience: suitable.map((d) => d.value),
        typeApproach: approach.map((d) => d.value),
        typeIssues: issue.map((d) => d.value),
        statusActivity: status.value,
        submission,

        typeVisibility: 1,
        typeSensitivity: 1,
      }
    }

    return output
  },
  formToRequestBody(form){
    let result = {}

    if(form){
      console.log('FORM BEFORE ADAPTED TO REQUEST BODY:', form)

      const {
        /* Program Profile */
        title_en,
        title_id,
        about_en,
        about_id,
        // image,

        /* Date & Location */
        start_date,
        end_date,
        // _locations,
        locations,

        /* Journeys */
        journeys,

        /* Beneficiaries */
        beneficiaries_gender_men,
        beneficiaries_gender_women,
        beneficiaries_gender_difable_men,
        beneficiaries_gender_difable_women,

        /* Impact - Baseline-Endline Survey */
        surveys = [],

        /* Impact - Retention */
        retention_pre_program_men,
        retention_pre_program_women,
        retention_post_program_men,
        retention_post_program_women,

        /* Impact - Satisfaction */
        satisfaction_very_satisfied,
        satisfaction_satisfied,
        satisfaction_neutral,
        satisfaction_disatisfied,
        satisfaction_very_disatisfied,

        /* Impact - NPS */
        nps_detractors,
        nps_passives,
        nps_promoters,
        nps_1,
        nps_2,
        nps_3,
        nps_4,
        nps_5,
        nps_6,
        nps_7,
        nps_8,
        nps_9,
        nps_10,

        cac,

        suitable = [],
        approach = [],
        issue = [],
        tags = [],
        // _partners = [],
        // partnerCreateHolder = [],
        partners = [],
        partners_external = [],
        officers = [],
        stories = [],
        gallery = [],
        milestones = [],
        files = [],

        events = [],
        organizationEvents = [],
        resources = [],
        organizationResources = [],
        blogs = [],
        organizationBlogs = [],

        submission,
      } = form

      const tanggalSelesaiFinal = dayjs(end_date).isBefore(start_date) ?
        new Date(start_date).toISOString() : new Date(end_date).toISOString()

      result = {
        judulActivity: [title_id, title_en],
        deskripsiPendek: [NAConverter(about_id), NAConverter(about_en)],
        deskripsiPanjang: [NAConverter(about_id), NAConverter(about_en)],
        tanggalMulai: new Date(start_date).toISOString(),
        tanggalSelesai: tanggalSelesaiFinal,

        // officer: [55202862, 87068436],
        officer: officers.map((o) => o.value),

        galleries: subAdapter.gallery.formToRequestBody(gallery),
        // galleries: [
        //   {
        //     deskripsiGambar: ["Deskripsi Gambar 1", "Picture Description 1"],
        //     typeVisibility: 1,
        //   },
        //   {
        //     deskripsiGambar: ["Deskripsi Gambar 2", "Picture Description 2"],
        //     typeVisibility: 1,
        //   },
        // ],

        // Only include new journey (with "NEW_" as id prefix)
        journey: journeys
          .filter((j) => j.id.slice(0, 4) === "NEW_")
          .map((j, index) => {
            const cloned = { ...j };

            // Make sure the journey will have an index
            if (!j.index) cloned.index = index;

            return subAdapter.journey.formToRequestBody(cloned);
          }),

        /* questions: subProgram & precedingProgram ini maksudnya apa? Dulu namanya subActivity & precedingActivity */
        subProgram: [],
        precedingProgram: [],

        events: [...events, ...organizationEvents].map((x) => x.id).filter(onlyUnique),
        resources: [...resources, ...organizationResources].map((x) => x.id).filter(onlyUnique),
        blogs: [...blogs, ...organizationBlogs].map((x) => x.id).filter(onlyUnique),
        activityResult: {
          beneficiariesMen: beneficiaries_gender_men || 0,
          beneficiariesWomen: beneficiaries_gender_women || 0,
          beneficiariesMenDifable: beneficiaries_gender_difable_men || 0,
          beneficiariesWomenDifable: beneficiaries_gender_difable_women || 0,

          retentionSaatProgramMen: retention_pre_program_men || 0,
          retentionSaatProgramWomen: retention_pre_program_women || 0,
          retentionPascaProgramMen: retention_post_program_men || 0,
          retentionPascaProgramWomen: retention_post_program_women || 0,

          satisfactionSangatTidakPuas: satisfaction_very_disatisfied || 0,
          satisfactionTidakPuas: satisfaction_disatisfied || 0,
          satisfactionNetral: satisfaction_neutral || 0,
          satisfactionPuas: satisfaction_satisfied || 0,
          satisfactionSangatPuas: satisfaction_very_satisfied || 0,

          netPromotorScoreDetractors: nps_detractors || 0,
          netPromotorScorePassive: nps_passives || 0,
          netPromotorScorePromoters: nps_promoters || 0,

          netPromotorScore1: nps_1 || 0,
          netPromotorScore2: nps_2 || 0,
          netPromotorScore3: nps_3 || 0,
          netPromotorScore4: nps_4 || 0,
          netPromotorScore5: nps_5 || 0,
          netPromotorScore6: nps_6 || 0,
          netPromotorScore7: nps_7 || 0,
          netPromotorScore8: nps_8 || 0,
          netPromotorScore9: nps_9 || 0,
          netPromotorScore10: nps_10 || 0,

          customerAcquisitionScore: parseInt(cac) || 0,
          baselineEndlineSurvey: subAdapter.survey.formToRequestBody(surveys),
        },
        coOwner: [],
        // coOwner: [49956271, 44093660],

        // Only include new location (with "NEW_" as id prefix)
        lokasi: locations
          .filter((d) => d.pkId.slice(0, 4) === "NEW_")
          .map((d) => subAdapter.location.formToRequestBody(d)),

        // Only include new milestone (with "NEW_" as id prefix)
        fase: milestones
          .filter((m) => m.id.slice(0, 4) === "NEW_")
          .map((m, index) => {
            const cloned = { ...m };

            // Make sure the milestone will have an index
            if (!m.index) cloned.index = index;

            return subAdapter.milestone.formToRequestBody(cloned);
          }),

        // Only include new partner
        // partnerActivityInternal: partnerCreateHolder,
        partnerActivityInternal: partners.map(p => p.id),
        partnerActivityEksternal: partners_external.map((d) => {
          return subAdapter.partner.external.formToRequestBody(d);
        }),
        // files: [],
        files: subAdapter.files.formToRequestBody(files),
        // files: [
        //   {
        //     embedLink: "https://issuu.com/pixelpi.site/docs/blank_black",
        //     deskripsiFile: ["Deskripsi File 1", "File Description 1"],
        //     typeVisibility: 1,
        //     isLimitedaccess: 1,
        //   },
        //   {
        //     embedLink: "https://issuu.com/pixelpi.site/docs/blank_black",
        //     deskripsiFile: ["Deskripsi File 1", "File Description 1"],
        //     typeVisibility: 1,
        //     isLimitedaccess: 1,
        //   },
        // ],
        // story_of_change: [36823693],
        storyOfChange: stories.map((s) => s.id),
        tag: tags.map((s) => s.value),
        statusActivity: 1,
        typeVisibility: 1,
        typeSensitivity: 1,
        vsbBlogs: 1,
        vsbTbJourney: 1,
        vsbTbCoOwner: 1,
        vsbTbSubActivity: 1,
        vsbTbPrecedingActivity: 1,
        vsbTbActivityResult: 1,
        vsbTbPartnerActivityInternal: 1,
        vsbTbPartnerActivityEksternal: 1,
        vsbJudulActivity: 1,
        vsbTanggalMulai: 1,
        vsbTanggalSelesai: 1,
        vsbThumbnail: 1,
        vsbMainImage: 1,
        vsbDeskripsiPendek: 1,
        vsbDeskripsiPanjang: 1,
        vsbTypeAudience: 1,
        vsbTypeApproach: 1,
        vsbTypeIssues: 1,
        vsbOfficer: 1,
        vsbStoryOfChange: 1,
        vsbEvents: 1,
        vsbResources: 1,
        typeAudience: suitable.map((d) => d.value),
        typeApproach: approach.map((d) => d.value),
        typeIssues: issue.map((d) => d.value),
        submission
      };
    }

    return result
  },

  responseBodyToForm(responseBody){
    const emptyForm = getEmptyForm()
    let result = emptyForm

    if(responseBody){
      const {
        programId,
        judulActivity = ['', ''],
        deskripsiPendek = ['', ''],
        tanggalMulai = '',
        tanggalSelesai = '',
        lokasi = [],
        journey = [],
        activityResult = {},
        tag = [],
        typeAudience = [],
        typeApproach = [],
        typeIssues = [],
        partnerActivityInternal = [],
        partnerActivityEksternal = [],
        galleries = [],
        fase = [],
        officer = [],
        storyOfChange = [],
        imgThumbnail,
        imgMainImage,
        files = [],
        events,
        resources,
        blogs,
        submission,
        catatanModerasi
      } = responseBody

      const {
        baselineEndlineSurvey,
        satisfactionSangatPuas,
        satisfactionPuas,
        satisfactionNetral,
        satisfactionTidakPuas,
        satisfactionSangatTidakPuas,
        pkActivityResultId
      } = activityResult

      result = {
        ...emptyForm,
        id: programId,
        title_en: judulActivity[1],
        title_id: judulActivity[0],
        about_en: deskripsiPendek[1],
        about_id: deskripsiPendek[0],
        image: api.base_image+imgMainImage,
        thumbnail: api.base_image+imgThumbnail,
        start_date: tanggalMulai.split('T')[0],
        end_date: tanggalSelesai.split('T')[0],
        _locations: lokasi,
        locations: subAdapter.location.responseBodyToForm(lokasi),
        journeys: subAdapter.journey.responseBodyToForm(journey),

        pkActivityResultId: pkActivityResultId,
        beneficiaries_gender_men: activityResult.beneficiariesMen,
        beneficiaries_gender_women: activityResult.beneficiariesWomen,
        beneficiaries_gender_difable_men: activityResult.beneficiariesMenDifable,
        beneficiaries_gender_difable_women: activityResult.beneficiariesWomenDifable,
        surveys: subAdapter.survey.responseBodyToForm(baselineEndlineSurvey),
        retention_pre_program_men: activityResult.retentionSaatProgramMen,
        retention_pre_program_women: activityResult.retentionSaatProgramWomen,
        retention_post_program_men: activityResult.retentionPascaProgramMen,
        retention_post_program_women: activityResult.retentionPascaProgramWomen,

        satisfaction_very_satisfied: satisfactionSangatPuas,
        satisfaction_satisfied: satisfactionPuas,
        satisfaction_neutral: satisfactionNetral,
        satisfaction_disatisfied: satisfactionTidakPuas,
        satisfaction_very_disatisfied: satisfactionSangatTidakPuas,

        nps_detractors: activityResult.netPromotorScoreDetractors,
        nps_passives: activityResult.netPromotorScorePassive,
        nps_promoters: activityResult.netPromotorScorePromoters,

        nps_1: activityResult.netPromotorScore1,
        nps_2: activityResult.netPromotorScore2,
        nps_3: activityResult.netPromotorScore3,
        nps_4: activityResult.netPromotorScore4,
        nps_5: activityResult.netPromotorScore5,
        nps_6: activityResult.netPromotorScore6,
        nps_7: activityResult.netPromotorScore7,
        nps_8: activityResult.netPromotorScore8,
        nps_9: activityResult.netPromotorScore9,
        nps_10: activityResult.netPromotorScore10,

        cac: activityResult.customerAcquisitionScore,
        tags: adapterTags(tag),
        suitable: adapterOptions(typeAudience),
        suitable__en: adapterOptions(typeAudience, 1),
        approach: adapterOptions(typeApproach),
        approach__en: adapterOptions(typeApproach, 1),
        issue: adapterOptions(typeIssues),
        issue__en: adapterOptions(typeIssues, 1),
        _partners: partnerActivityInternal,
        // saved: already saved in database
        partners_saved: partnerActivityInternal.map(i => {
          return {
            pkId: i.pkPartnerActivityInternalId,
            name: i.partner && i.partner !== null ? i.partner.namaOrganisasi : 'null',
            id: i.partner && i.partner !== null ? i.partner.organisasiId : null,
            image: i.partner && i.partner !== null ? api.base_image+i.partner.imgLogoOrganisasi : null
          }
        }),
        partners: [],
        partners_external_saved: partnerActivityEksternal.map(i => {
          return {id: i.pkPartnerActivityEksternalId, name: i.namaPartner, image: api.base+i.imgLogoPartner, website: i.websitePartner}
        }),
        partners_external: [],
        _gallery: galleries,
        gallery: galleries.map(g => api.base_image+g.imgGambar),
        _files: files,
        files: files.map(f => api.base_image+f.binFile),
        milestones: subAdapter.milestone.responseBodyToForm(fase),
        officers: officer.map(o => {
          return {
            fromResponseBody: true,
            label: o.namaIndividu,
            value: o.userId,
            name: o.namaIndividu,
            id: o.userId,
            image: api.base_image+o.imgFotoProfile
          }
        }),
        stories: storyOfChange.map(story => {
          return {
            id: story.blogId,
            title: null,
            description: {
              en: story.deskripsiPendek[1],
              id: story.deskripsiPendek[0]
            }
          }
        }),
        // events: events.map(e => eventAdapter.responseBodyToRender(e)),
        organizationEvents: events.map(e => eventAdapter.responseBodyToRender(e)),
        // blogs: blogs.map(e => blogAdapter.responseBodyToRender(e)),
        organizationBlogs: blogs.map(e => blogAdapter.responseBodyToRender(e)),
        // resources: resources.map(e => resourceAdapter.responseBodyToRender(e)),
        organizationResources: resources.map(e => resourceAdapter.responseBodyToRender(e)),

        submission_status_id: submission,
        reason: catatanModerasi
      }
    }

    return result
  },
}

/* Helpers */
function getEmptyForm(){
  return {
    id: '',
    title_en: '',
    title_id: '',
    about_en: '',
    about_id: '',
    start_date: '',
    end_date: '',
    locations: [],
    milestones: [],
    journeys: [],
    beneficiaries_gender_men: 0,
    beneficiaries_gender_women: 0,
    beneficiaries_gender_difable_men: 0,
    beneficiaries_gender_difable_women: 0,
    surveys: [],
    retention_pre_program_men: 0,
    retention_pre_program_women: 0,
    retention_post_program_men: 0,
    retention_post_program_women: 0,
    satisfactions: [],
    nps: [],
    cac: '0',
    stories: [],
    events: [],
    resources: [],
    blogs: [],
    suitable: [],
    approach: [],
    issue: [],
    tags: [],
    acceptance_status: null,
    status: null
  }
}

// function filterAlreadyInDatabase_location(locationsInForm, locationsInDatabase){
//   let result = []

//   for (let index = 0; index < locationsInForm.length; index++) {
//     const element = locationsInForm[index];
//     let alreadyInDatabase = false

//     for (let index1 = 0; index1 < locationsInDatabase.length; index1++) {
//       const element1 = locationsInDatabase[index1];
//       if(element1.pkLokasiActivityId === element){
//         alreadyInDatabase = true
//       }
//     }

//     if(alreadyInDatabase === false){
//       result.push(element)
//     }
//   }

//   return result
// }

// function filterAlreadyInDatabase(partnersInForm, partnersInDatabase){
//   let result = []

//   for (let index = 0; index < partnersInForm.length; index++) {
//     const element = partnersInForm[index];
//     let alreadyInDatabase = false

//     for (let index1 = 0; index1 < partnersInDatabase.length; index1++) {
//       const element1 = partnersInDatabase[index1];
//       if(element1.pkPartnerActivityInternalId === element){
//         alreadyInDatabase = true
//       }
//     }

//     if(alreadyInDatabase === false){
//       result.push(element)
//     }
//   }

//   return result
// }

export { subAdapter }

export default adapter
